export const PAGE_TITLE = 'CFG-UI';

export const AUTH_URL = '/CFG-API';
export const BASE_URL = '/CFG-API/v0.1';
export const GEOSERVER_URL = '/geoserver';

export const GLOBAL_MAP_ID = 0;

export const LOGIN_REGEX = /^[a-zA-Z][a-zA-Z0-9[\-_.~]*]*$/;
export const PASSWORD_REGEX = /^[a-zA-Z0-9[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]*]*$/;

export const BROWSER_LOCALE = 'browser';

export enum ApiFilterOperator {
  GROUP_START = '[',
  GROUP_FINISH = ']',
  IN_SEPARATOR = '|',
  OR = ',',
  AND = ';',
  EQUALS = '==',
  NOT_EQUALS = '!=',
  CONTAINS = '=@',
  LESS = '<',
  MORE = '>',
  LESS_OR_EQUALS = '<=',
  MORE_OR_EQUALS = '>=',
  LABELED = '=#',
  LABELED_ALL = '>#',
  UNIQUE = '=^',
}

export enum TagAnchorFetchContext {
  FW_INFO = 'fw',
  HW_ID = 'hwid',
  UWB_SIG = 'sig',
  UWB_TUNE = 'tune',
  UWB_ROLE = 'role',
  LAST_RESET = 'uptime',
  SUPERVISOR = 'supervisor',
  QUERY = 'query',
}

export const tagFetchContexts = [
  TagAnchorFetchContext.FW_INFO,
  TagAnchorFetchContext.HW_ID,
  TagAnchorFetchContext.UWB_SIG,
  TagAnchorFetchContext.UWB_TUNE,
  TagAnchorFetchContext.UWB_ROLE,
  TagAnchorFetchContext.LAST_RESET,
  TagAnchorFetchContext.SUPERVISOR,
  TagAnchorFetchContext.QUERY,
];

export const anchorFetchContexts = [
  TagAnchorFetchContext.FW_INFO,
  TagAnchorFetchContext.HW_ID,
  TagAnchorFetchContext.UWB_SIG,
  TagAnchorFetchContext.UWB_TUNE,
  TagAnchorFetchContext.UWB_ROLE,
  TagAnchorFetchContext.LAST_RESET,
  TagAnchorFetchContext.QUERY,
];
